function updateCartBubble() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const bubbleVisible = document.querySelector(".cart-count-bubble span[aria-hidden='true']");
      const bubbleHidden = document.querySelector(".cart-count-bubble .visually-hidden");
      if (bubbleVisible) bubbleVisible.textContent = cart.item_count;
      if (bubbleHidden) bubbleHidden.textContent = `${cart.item_count} items`;
    })
    .catch(err => console.error('[Cart Bubble] Update failed:', err));
}

// Update bubble on page load
document.addEventListener("DOMContentLoaded", updateCartBubble);

// Update bubble when coming back via browser back button
window.addEventListener("pageshow", updateCartBubble);
